import { countOverdue } from "features/labOrders/utils/outstandingLabTests";

import { useOutstandingLabTests } from "./useOutstandingLabTests";

// An overdue test is not a fast-moving event — it became overdue by sitting there — and
// this runs on every page, so it polls on the same minute as the unassigned results
// count rather than more often.
const REFETCH_INTERVAL_MS = 60000;

/**
 * How many eLab tests are past the time the laboratory should have answered by
 * (KIN-2087).
 *
 * Asks the server for the overdue tests only, so the count costs a short list rather
 * than the whole worklist on every screen. It is empty until turnaround figures are
 * configured — the backend has no clock to measure against before that — and a zero
 * count shows no badge at all.
 */
export const useOverdueLabTestsCount = ({ enabled = true } = {}) => {
  const query = useOutstandingLabTests({
    overdueOnly: true,
    enabled,
    refetchInterval: REFETCH_INTERVAL_MS,
  });

  return { ...query, data: countOverdue(query.data ?? []) };
};
